// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // Initialize Firebase
  firebaseConfig: {
    apiKey: 'AIzaSyDjyrR4mtCvjZ3s0DpF2QW2ABtKFhuTGxs',
    authDomain: 'umakeit-55b12.firebaseapp.com',
    databaseURL: 'https://umakeit-55b12.firebaseio.com',
    projectId: 'umakeit-55b12',
    storageBucket: 'umakeit-55b12.appspot.com',
    messagingSenderId: '830750606087'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
